<script setup lang="ts">
import model from '@/ts/model';
import { getLangText } from '@/ts/utils/model-utils';
</script>

<template>
    <teleport to="body" defer>
        <div class="internet-connection-problem">
            <div class="inner" :class="[model.internetConnProblem.status]">
                <template v-if="model.internetConnProblem.status === 'resolved' || model.internetConnProblem.status === 'ok'">
                    {{ getLangText('NetworkConnResolved') }}
                </template>
                <template v-else-if="model.internetConnProblem.status === 'error'">
                    {{ getLangText('NetworkConnError') }}
                </template>
            </div>
        </div>
    </teleport>
</template>

<style lang="scss" scoped>
    .internet-connection-problem{
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30px;
        z-index: 9999;
        pointer-events: none;
        & > .inner{
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: inset 0 0 0 2px #fff;
            padding: 0 40px;
            align-self: stretch;
            border-top-left-radius: 100px;
            border-top-right-radius: 100px;
            transition: transform .25s;
            &.ok,
            &.resolved{
                background-color: rgb(0, 189, 0);
            }
            &.error{
                background-color: rgb(189, 0, 0);
            }
            &.ok{
                transform: translateY(100%);
            }
        }
    }
</style>